module.exports = __webpack_public_path__ + "img/151.5fa7ab20.png";